import { useTranslation } from 'react-i18next'
import { CreateButton } from '~/components/refineUi/buttons/create'
import { Button } from '~/components/ui/button'

/** Shown instead of the table when a list has no rows. */
export function ListEmptyState({
  resource,
  label = '',
  hasFilters,
  onClearFilters,
  canCreate = true,
  noMatchText,
  emptyText,
}: {
  resource: string
  /** plural, lower case: "No {label} yet" */
  label?: string
  hasFilters: boolean
  onClearFilters: () => void
  /** false for read-only resources: no Create button */
  canCreate?: boolean
  /** shown with filters; default "No {label} match the filters." */
  noMatchText?: string
  /** whole sentence shown without filters; default "No {label} yet" */
  emptyText?: string
}) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center gap-3 rounded-md border border-dashed p-10 text-center">
      {hasFilters ? (
        <>
          <p className="font-medium">{t('shell.listEmpty.noResults')}</p>
          <p className="text-muted-foreground text-sm">
            {noMatchText ?? t('shell.listEmpty.noMatch', { label })}
          </p>
          <Button
            variant="outline"
            onClick={onClearFilters}
          >
            {t('shell.listEmpty.clearFilters')}
          </Button>
        </>
      ) : (
        <>
          <p className="font-medium">
            {emptyText ?? t('shell.listEmpty.noneYet', { label })}
          </p>
          {canCreate && (
            <CreateButton
              resource={resource}
              accessControl={{ hideIfUnauthorized: true }}
            />
          )}
        </>
      )}
    </div>
  )
}
